module.exports = __webpack_public_path__ + "static/media/tick_purple.6b773c9b.webp";